import React from "react";
// import ParallaxBanner from "../ParallaxBanner/ParallaxBanner";
// import Hubspot from "react-hubspot-form";

const CLMNewsletter = ({config, cdnpath}) => {
    return (
        <div className="background-secondary">
            <div className="CLMNewsletter">
                {/* <ParallaxBanner
                    image={`/assets/${config.banner}`}
                    speed={0.5}
                    height="240px"
                > */}
                <div id="NewsletterSignUp">
                    {/* <h4 className="text-white">E-Newsletter Sign-up</h4> */}
                    {/* <Hubspot
                        portalId="547446"
                        formId="c78de44f-4cf1-4a5b-a472-b462a5916120"
                        loading={<div>Loading...</div>}
                    /> */}
                    <div className="cover-img">
                        <img src={`${cdnpath}assets/${config.image.src}`} alt={config.image.alt} title={config.image.title} style={{width: "358px", height: "300px"}}/>
                    </div>
                    <div className="cover-text">
                        <div className="h1 text-white">{config.title}</div>
                        <p className="text-white">{config.summary}</p>
                        <button className="action-btn btn brandedButton inverted" onClick={() => {
                            window.location = config.button.url ? config.button.url : "/";
                        }}>{config.button.text}</button>
                    </div>
                </div>
                {/* </ParallaxBanner> */}
            </div>
        </div>
    );
};

export default CLMNewsletter;
